"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.rule)({
    d: 'block',
    bxz: 'border-box',
    bdrad: '4px',
});
const defaultClass = (0, nano_theme_1.drule)({});
const buttonClass = (0, nano_theme_1.drule)({
    op: 0.45,
});
const LINE_RATIOS = [0.8, 0.65, 0.5, 0.72, 0.58];
const DEFAULTS = {
    text: { width: '60%', height: '12px', bdrad: '3px' },
    button: { width: '40%', height: '36px', bdrad: '18px' },
    paragraph: { width: '100%', height: 'auto' },
    image: { width: '100%', height: '200px', bdrad: '6px' },
    card: { width: '100%', height: '300px', bdrad: '8px' },
    block: { width: '100%', height: '48px' },
};
const Placeholder = ({ variant = 'block', width, height, lines = 3, style }) => {
    const styles = (0, context_1.useStyles)();
    const defaultCls = defaultClass({ bg: styles.g(0, styles.light ? 0.09 : 0.14) });
    const buttonCls = buttonClass({ bg: styles.col.get('link', 'solid-1') });
    const def = DEFAULTS[variant];
    if (variant === 'paragraph') {
        return (React.createElement("span", { style: { display: 'block', ...(style || {}) } }, Array.from({ length: lines }, (_, i) => (React.createElement("span", { key: i, className: `${blockClass} ${defaultCls}`, style: {
                display: 'block',
                width: `${LINE_RATIOS[i % LINE_RATIOS.length] * 100}%`,
                height: '12px',
                marginBottom: i < lines - 1 ? '6px' : 0,
            } })))));
    }
    return (React.createElement("span", { className: `${blockClass} ${variant === 'button' ? buttonCls : defaultCls}`, style: {
            width: width ?? def.width,
            height: height ?? def.height,
            borderRadius: def.bdrad,
            ...style,
        } }));
};
exports.Placeholder = Placeholder;
